import { cn } from '@/lib/core';

/**
 * Centered section heading with a rule on each side, e.g. "APRIL 9" or
 * "CURRENT CAMPAIGNS". Matches the `date divider` node in the ELP design.
 */
export function DateDivider({ label, className }: { label: string; className?: string }) {
  return (
    <div className={cn('flex w-full items-center gap-2 py-1', className)}>
      <span className="bg-jncquoi-neutral-200 h-px flex-1" aria-hidden="true" />
      <span className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[10px] tracking-[0.5px] whitespace-nowrap uppercase">
        {label}
      </span>
      <span className="bg-jncquoi-neutral-200 h-px flex-1" aria-hidden="true" />
    </div>
  );
}
